var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('span',{class:_vm.cssClass,attrs:{"title":_vm.title}},[_c('time',{attrs:{"datetime":_vm.date.toISOString(),"title":_vm.showTime ? _vm.date.toLocaleString() : _vm.date.toLocaleDateString()}},[(_vm.showTime)?[_vm._v(" "+_vm._s(_vm.date.toLocaleString())+" ")]:[_vm._v(" "+_vm._s(_vm.date.toLocaleDateString())+" ")]],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }